import { Expose, Type } from 'class-transformer';
import { FeatureCollection } from 'geojson';

import { SnCollection } from '@lib/common/models';

import { SnBaseLayer } from './base-layer';
import { SnLayerObject } from './layer-feature';
import { SnLayerType } from './layer-type';

export class SnExternalLayer extends SnBaseLayer {
  @Expose()
  public externalName: string;

  @Expose()
  @Type(() => SnLayerObject)
  public objects: SnCollection<SnLayerObject>;

  public readonly type = SnLayerType.External;

  public toGeoJSON(): FeatureCollection {
    return {
      type: 'FeatureCollection',
      features: this.objects.map((object) => object.toGeoJSON()),
    };
  }
}
